import { render } from "./GirlsCouncil.vue?vue&type=template&id=56048948&scoped=true"
import script from "./GirlsCouncil.vue?vue&type=script&lang=js"
export * from "./GirlsCouncil.vue?vue&type=script&lang=js"

import "./GirlsCouncil.vue?vue&type=style&index=0&id=56048948&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56048948"]])

export default __exports__